document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
});

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-miniatura]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.dataset.mtTarget;
      var target = document.getElementById(targetId);
      if (!target) return;
      target.src = btn.dataset.mtSrc;
      var grupo = btn.closest('.mt-prod__miniaturas');
      if (grupo) {
        grupo.querySelectorAll('.mt-prod__miniatura').forEach(function (b) { b.classList.remove('mt-activa'); });
      }
      btn.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (select) {
    var seccionId = select.dataset.mtProducto;
    var form = select.closest('form');
    if (!form) return;
    var todosLosSelects = form.querySelectorAll('[data-mt-producto="' + seccionId + '"]');
    var variantesEl = document.getElementById('mt-variantes-' + seccionId);
    if (!variantesEl) return;
    var variantes;
    try { variantes = JSON.parse(variantesEl.textContent); } catch (e) { return; }

    select.addEventListener('change', function () {
      var seleccion = Array.from(todosLosSelects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      var idInput = document.getElementById('mt-variant-id-' + seccionId);
      if (idInput) idInput.value = variante.id;

      var boton = document.getElementById('mt-boton-comprar-' + seccionId);
      if (boton) {
        boton.disabled = !variante.available;
        var textoDisponible = boton.querySelector('[data-mt-texto-disponible]');
        var textoAgotado = boton.querySelector('[data-mt-texto-agotado]');
        if (textoDisponible && textoAgotado) {
          textoDisponible.style.display = variante.available ? '' : 'none';
          textoAgotado.style.display = variante.available ? 'none' : '';
        }
      }

      var precioEl = document.querySelector('#shopify-section-' + seccionId + ' .mt-prod__precio-actual');
      if (precioEl && window.Shopify && window.Shopify.formatMoney) {
        precioEl.textContent = window.Shopify.formatMoney(variante.price, window.Shopify.money_format);
      }
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;
  if (!('IntersectionObserver' in window)) {
    contadores.forEach(function (el) { el.textContent = el.dataset.mtContador; });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animarContador(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );
  contadores.forEach(function (el) { observer.observe(el); });
}

function animarContador(el) {
  var destino = parseFloat(el.dataset.mtContador);
  var sufijo = el.dataset.mtSufijo || '';
  if (isNaN(destino)) return;
  var duracion = 1400;
  var inicio = null;
  function paso(timestamp) {
    if (!inicio) inicio = timestamp;
    var progreso = Math.min((timestamp - inicio) / duracion, 1);
    var valor = Math.floor(progreso * destino);
    el.textContent = valor + sufijo;
    if (progreso < 1) {
      window.requestAnimationFrame(paso);
    } else {
      el.textContent = destino + sufijo;
    }
  }
  window.requestAnimationFrame(paso);
}
